import React, { Component } from 'react';
import LargeHeading from "../components/LargeHeading";
import JoshSvg from "../components/JoshSvg";
import { isMobile } from "react-device-detect";

class Why extends Component {

    render() {
        return (
            <section className="why" {...this.props}>
                <div className="inner">
                    <LargeHeading title={isMobile ? 'Who Am I' : 'Me, Myself and I'} />
                    <div className="content">
                        <p style={{marginTop: 0}}>Hello! I have been an engineer for over 12 years, and I love it. Learning the new and constantly improving technologies excites me, and I love to challenge myself. I am always open to learning something new, and as a senior I, of course, appreciate clean, structured, future-proof, well written code.</p>
                        <p>I am a huge personality in any team I work in, and I pride myself on always bringing a positive energy <span role="img" aria-label="Smile">😄</span>. I have worked in both frontend, backend and full-stack environments, and I have led engineering teams in both New Zealand and in Australia. </p>
                        <p>I am currently on the lookout for projects where I can work 100% remotely.</p>
						<div className="bg">
							<div className="portrait-inner">
								<JoshSvg />
								<JoshSvg />
								<JoshSvg />
								<JoshSvg />
							</div>
						</div>
                    </div>
                </div>
            </section>
        );
    }

}

export default Why;


// WEBPACK FOOTER //
// ./src/js/views/Why.js